export default __webpack_public_path__ + "static/media/sentro_vertical.bfac8b24.png";